import { BudgetData, BudgetHeader, BudgetInfo, BudgetType } from '@shared/services/gql.service';
import { RequireSome } from '@shared/utils/utils';

export interface BudgetState {
  budget_data: ExtendedBudgetData[];
  budget_info: BudgetInfo[];
  budget_type: BudgetType;
  current_data: ExtendedBudgetData[];
  header_data: RequireSome<BudgetHeader, 'date_headers'>[];
  invoices: { [key: string]: { [key: string]: string } };
  pendingChanges: { [key: string]: string };
  work_performed: { [key: string]: { [key: string]: string } };
}

export type ExtendedBudgetData = BudgetData &
  Record<string, number | string> & {
    accrual: number;
    accrual_adjusted_obj: Record<string, number>;
    accrual_obj: Record<string, number>;
    accrual_override: Record<string, number>;
    adjustment: number;
    adjustment_obj: Record<string, number>;
    current_lre: number;
    exchange_rate: Record<string, number>;
    forecast: number;
    forecast_obj: Record<string, number>;
    remaining_cost: number;
    remaining_percentage: number;
    remaining_unit_num: number;
    total_monthly_accrual: number;
    wp_cost: number;
    wp_ltd: number;
    wp_percentage: number;
    wp_unit_num: number;
  };

export function createInitialState(budget_type?: BudgetType): BudgetState {
  return {
    budget_data: [],
    budget_info: [],
    budget_type: budget_type || BudgetType.BUDGET_PRIMARY,
    current_data: [],
    header_data: [],
    invoices: { vendor_id: { invoice_total: '$0' } },
    pendingChanges: { vendor_id: '' },
    work_performed: { vendor_id: { invoice_total: '$0' } },
  };
}
